import { render } from "./GameTestButton.vue?vue&type=template&id=d0b9c166&scoped=true"
import script from "./GameTestButton.vue?vue&type=script&lang=ts"
export * from "./GameTestButton.vue?vue&type=script&lang=ts"

import "./GameTestButton.vue?vue&type=style&index=0&id=d0b9c166&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d0b9c166"

export default script